import './index.less';

import { Spin } from '@bfe/moly';
import { Button } from 'antd';
import { FC, useEffect, useRef, useState } from 'react';

import { IParentPermission } from '@/services/types/apiManagement';

import BaseInput from './comps/BaseInput';
import CreateApiForm from './comps/CreateApiForm';
import RedirectUrls from './comps/RedirectUrlsInput';
import Secret from './comps/Secret';
import { SecretModal } from './comps/SecretModal';
import Tabs from './comps/Tabs';
import UploadImage from './comps/Upload';
import { IBaseInput, tabType } from './type';
import { useOauthAdmin } from './useOauthAdmin';

export interface IOpenApiFormRef {
  getOpenApiFormValues: () => {
    readOnly: boolean;
    bindIps: string;
    permissions: { [key: string]: string[] };
  };
  validateOpenApiForm: () => Promise<boolean>;
}

const OauthAdmin: FC = () => {
  const openApiFormRef = useRef<IOpenApiFormRef>();
  const {
    baseData,
    netDomainData,
    activeTab,
    showDetailModal,
    appName,
    clientId,
    clientSecret,
    apiDetail,
    hasAuth,
    logoUrl,
    $t,
    setLogoUrl,
    setActiveTab,
    setShowDetailModal,
    handleSubmit,
    formatApiDetail,
    underSubmission,
  } = useOauthAdmin();

  const [updateOpenApiForm, setUpdateOpenApiForm] = useState(false);
  useEffect(() => {
    if (activeTab !== tabType.CONFIG_APP) {
      setUpdateOpenApiForm(false);
    } else {
      setUpdateOpenApiForm(true);
    }
  }, [activeTab]);

  return (
    <div className="oauth-admin-container">
      <div className="oauth-admin-container-box">
        <div className="oauth-admin-container-box-title" data-paint>
          {$t('oauthAdmin.title')}
        </div>
        {hasAuth ? (
          <>
            <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
            {activeTab === tabType.CONFIG_APP ? (
              <Spin spinning={underSubmission}>
                <div className="oauth-admin-container-box-content">
                  {baseData.map((item: IBaseInput) => (
                    <BaseInput
                      key={item.key}
                      title={item.title}
                      val={item.val}
                      placeholder={item.placeholder}
                      handleChange={item.handleChange(item.key)}
                      required={item.required}
                      isValidVal={item.isValidVal}
                    />
                  ))}
                  <div className="content-plain-title">
                    <span className="content-plain-title-required">*</span>
                    {$t('oauthAdmin.appLogo')}
                  </div>
                  <div className="logo-desc">
                    {$t('oauthAdmin.appLogoDesc')}
                  </div>
                  <div className="logo-upload">
                    <UploadImage logoUrl={logoUrl} setLogoUrl={setLogoUrl} />
                  </div>
                  <div className="content-hr-line"></div>
                  <div className="content-bold-title">
                    {$t('oauthAdmin.netDomain')}
                  </div>
                  <div className="content-text-gray">
                    {$t('oauthAdmin.netDomainDesc')}
                  </div>
                  {netDomainData.map((item: IBaseInput) => {
                    if (item.key === 'homepageUrl') {
                      return (
                        <RedirectUrls
                          key={item.key}
                          initialValue={item.val}
                          title={item.title}
                          placeholder={item.placeholder}
                          required={item.required}
                          onChange={item.handleChange(item.key)}
                        />
                      );
                    }
                    return (
                      <BaseInput
                        key={item.key}
                        title={item.title}
                        val={item.val}
                        placeholder={item.placeholder}
                        handleChange={item.handleChange(item.key)}
                        required={item.required}
                        isValidVal={item.isValidVal}
                      />
                    );
                  })}
                  <div className="content-hr-line"></div>
                  <div className="content-bold-title">
                    {$t('oauthAdmin.helpToCreateOpenApi')}
                  </div>
                  <div className="content-create-api">
                    <CreateApiForm
                      ref={openApiFormRef}
                      apiDetail={apiDetail}
                      updateOpenApiForm={updateOpenApiForm}
                      onValuesChange={(values) => {
                        if (values.bindIps || values.permissions) {
                          setUpdateOpenApiForm(false);
                          formatApiDetail({
                            ips: apiDetail.bindIps,
                            read_only: values.readOnly,
                            permissions:
                              values.permissions as unknown as IParentPermission,
                          });
                        }
                      }}
                      // onChangeIpRight={(event) => {
                      //   setInvalidIp(!event);
                      // }}
                    />
                  </div>
                  {/* <BaseInput
                  key="ip"
                  title={'*您请求的Bybit 机器 ip'}
                  val={ipVal}
                  placeholder={'Bybit 使用该邮箱地址通知项目变更'}
                  handleChange={handleIpValChange('ip')}
                /> */}
                  {/* <div className="content-ips-box">
                  <TextArea
                    className={invalidIp ? 'error' : ''}
                    value={ipVal}
                    style={{ width: 480 }}
                    placeholder={`${$t('addIpsLabel')}${String.fromCharCode(
                      10,
                    )}${$t('api.if')}: 192.168.1.1,192.168.1.1,192.168.1.3`}
                    onChange={handleIpValChange}
                  />
                  {invalidIp && (
                    <div className="content-ips-box-error">
                      {$t('IPInvalid')}
                    </div>
                  )}
                </div> */}
                  <div className="content-hr-line"></div>
                  <Button
                    type="primary"
                    style={{ color: 'var(--bds-gray-t1-title)' }}
                    onClick={async () => {
                      try {
                        await openApiFormRef?.current?.validateOpenApiForm();
                      } catch (error) {
                        console.log('oauth admin form verify error');
                      }
                      const values =
                        openApiFormRef?.current?.getOpenApiFormValues() || {
                          bindIps: '',
                          readOnly: true,
                          permissions: {},
                        };
                      handleSubmit(values);
                    }}
                  >
                    {$t('Submit')}
                  </Button>
                </div>
              </Spin>
            ) : (
              <Secret setActiveTab={setActiveTab} />
            )}
          </>
        ) : (
          <div className="no-admin-page-auth">{$t('oauthAdmin.noAuth')}</div>
        )}
      </div>
      <SecretModal
        showDetailModal={showDetailModal}
        apiKeyInfo={{
          apiKey: clientId,
          note: appName,
          secret: clientSecret,
        }}
        closeModal={() => setShowDetailModal(false)}
      />
    </div>
  );
};

export default OauthAdmin;
